import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const InctvLedgerLineList = ({ inctvLedgerObj: inctvLedger }) => {
  const augRowsReq = useCallback((rowsReq) => {
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('inctvLedgerId', inctvLedger.id));
  }, []);

  return <EntityList entity="INCTV_LEDGER_LINE" augRowsReq={augRowsReq} />;
};
